<kpi-comments-skeleton *ngIf="isLoading"></kpi-comments-skeleton>

<div *ngIf="!isLoading" [cdkTrapFocusAutoCapture]="true" cdkTrapFocus>
  <div class="header">
    <h5>{{ "comments" | localize }}</h5>
    <div class="actions">
      <button *hasPermissions="'ManageKPIs'" (click)="openCommentForm()" ui-button uiType="default" uiShape="round" data-test-id="kpi-comments-add-comment-button">
        {{ "add_comment" | localize }}
      </button>
      <button uiSref="^" ui-modal-close></button>
    </div>
  </div>

  <div class="body" *ngIf="!error; else errorTemplate">
    <div class="empty-state" *ngIf="leadingComments.length === 0">{{ "no_comments_yet" | localize }}</div>
    <div class="leading-comment" *ngFor="let comment of leadingComments" tabindex="0">
      <ui-badge [uiStandalone]="true" [uiCount]="comment.unreadCommentsCount" [uiOverflowCount]="10"></ui-badge>
      <comment
        [hideCommentOptionsDropdown]="true"
        [comment]="comment"
        [target]="{ id: this.kpiId, type: comment.targetType, date: comment.formattedTargetDate }"
        [hideReactions]="true"
        [hideMentions]="true"></comment>
      <thread-footer [commentId]="comment.id" [usersReplied]="comment.usersReplied" [lastReplyAt]="comment.lastReplyAt" [repliesCount]="comment.repliesCount"></thread-footer>
    </div>
  </div>
</div>

<ng-template #errorTemplate>
  <div class="error-template">
    <i class="error-icon" ui-icon uiType="attention" uiTheme="fill"></i>
    <div class="error-title">{{ error.title }}</div>
    <div class="error-message">{{ error.message }}</div>
  </div>
</ng-template>
